import React from "react";
import { Route, Redirect } from 'react-router-dom';

function ProtectedRoute({ children }) {

    const isLogin = localStorage.getItem("token");
    console.log("Is User Login?", isLogin);

    return (
        isLogin ? children : <Redirect to={{ pathname: '/Login' }} />
    );
}

export default ProtectedRoute;